import { fetcher } from './fetcher.js';

export const recipeFavorite = {
  init() {
    const likeButton = document.querySelector('.js-recipe-like-button');
    const dislikeButton = document.querySelector('.js-recipe-dislike-button');
    const recipeId = parseInt(document.querySelector('.js-recipe-id')?.dataset?.recipeId);
    const bearerToken = document.querySelector('#bearer_token').textContent;
    const data = { recipeId, bearerToken, dislikeButton, likeButton };
    const likedRecipes = store.get('likedRecipes');
    const goBackLink = document.querySelector('.js-go-back');
    likeButton && likeButton.addEventListener('click', () => this.actionLike(data));
    dislikeButton && dislikeButton.addEventListener('click', () => this.actionDislike(data));
    likedRecipes && this.isCurrentRecipeFavorite(likedRecipes, recipeId) && this.setLikedRecipesState();
    !likedRecipes && this.saveRecipesInStorage(bearerToken, recipeId);
    goBackLink && goBackLink.addEventListener('click', this.goBack);
  },
  goBack(e) {
    e.preventDefault();
    store.remove('portions');
    if (history.length === 1) {
      window.close();
    } else {
      window.location.href = e.currentTarget.href;
    }
  },
  actionLike(data) {
    data.likeButton.disabled = true;
    data.dislikeButton.disabled = false;

    const url = `${window.getHost()}/api/recipes/${data.recipeId}/favorite`;
    fetcher
      .post(url, {}, { Accept: 'application/json', Authorization: 'Bearer ' + data.bearerToken })
      .then(() => {
        this.setLikedRecipesState();
        this.addNewLike(data.recipeId);
      })
      .catch(() => {
        data.likeButton.disabled = false;
        data.dislikeButton.disabled = true;
      });
  },
  actionDislike(data) {
    data.dislikeButton.disabled = true;
    data.likeButton.disabled = false;
    const url = `${window.getHost()}/api/recipes/${data.recipeId}/favorite`;
    fetcher
      .del(url, { Accept: 'application/json', Authorization: 'Bearer ' + data.bearerToken })
      .then(() => {
        this.setLikedRecipesState();
        this.removeLike(data.recipeId);
      })
      .catch(() => {
        data.dislikeButton.disabled = false;
        data.likeButton.disabled = true;
      });
  },
  addNewLike(recipeId) {
    const likedRecipes = store.get('likedRecipes') || [];
    const recipeIds = [...likedRecipes, parseInt(recipeId)];
    store.set('likedRecipes', recipeIds);
  },
  removeLike(recipeId) {
    const recipeIds = store.get('likedRecipes').filter(id => id != recipeId);
    store.set('likedRecipes', recipeIds);
  },
  setLikedRecipesState() {
    const buttons = document.querySelectorAll('.js-like');
    buttons.forEach(button => button.classList.toggle('hidden'));
  },
  isCurrentRecipeFavorite(likedRecipes, current) {
    return likedRecipes.includes(current);
  },
  saveRecipesInStorage(bearerToken, currentRecipeId) {
    const url = `${window.getHost()}/api/recipes/favorite`;

    fetcher.get(url, { Accept: 'application/json', Authorization: 'Bearer ' + bearerToken }).then(({ data }) => {
      store.set('likedRecipes', data);
      this.isCurrentRecipeFavorite(data, currentRecipeId) && this.setLikedRecipesState();
    });
  },
};

document.addEventListener('DOMContentLoaded', () => {
  recipeFavorite.init();
});
